<mat-card class="decoration-card">
    <mat-card-content>
        <mat-toolbar *ngIf="hasEditorRight">
            <button mat-icon-button matTooltip="update" (click)="updateTrail()" [disabled]="!isContentChanged"
                *ngIf="!isReadonly">
                <mat-icon>save</mat-icon>
            </button>
            
            <button mat-icon-button matTooltip="copy trial as template" (click)="btnCopyAsTemplateClicked()" *ngIf="hasManagerRight && !isReadonly">
                 <mat-icon>file_copy</mat-icon>
            </button>
            
            <button mat-icon-button matTooltip="delete trial template" (click)="btnDeleteTemplateClicked()" *ngIf="hasManagerRight && !isReadonly">
                <mat-icon>delete</mat-icon>
            </button>

            <span class="example-spacer"></span>

            <button mat-icon-button matTooltip="Generate and download a trial report" (click)="generateTrialReport()" *ngIf="hasEditorRight">
                <mat-icon>library_books</mat-icon>
            </button>
            <!--
            <button mat-icon-button matTooltip="Generate and download a trial report in DNV format" (click)="getTrialReport('dnv')">
                <mat-icon>cloud_queue</mat-icon>
            </button>
            <button mat-icon-button matTooltip="Generate and download a trial report in N-Denton format" (click)="getTrialReport('ndt')">
                <mat-icon>cloud_download</mat-icon>
            </button>
            -->

            <button mat-icon-button matTooltip="add a trial" (click)="createTrail()" *ngIf="!isReadonly">
                <mat-icon>plus_one</mat-icon>
            </button>

            <button mat-icon-button matTooltip="delete" (click)="btnDeleteClicked()" *ngIf="!isReadonly">
                <mat-icon>delete_outline</mat-icon>
            </button>

        </mat-toolbar>

        <form class="example-form" (change)="onContentChange()">
            <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                <mat-label>Name</mat-label>
                <input matInput type="text" name="Name" [(ngModel)]="trail.name" [readonly]="isReadonly">
            </mat-form-field>

            <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                <mat-label>Office</mat-label>
                <input matInput type="text" name="office" [(ngModel)]="trail.office" [readonly]="isReadonly">
            </mat-form-field>

            <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                <mat-label>Description</mat-label>
                <textarea matInput type="text" name="description" [(ngModel)]="trail.description"
                    [readonly]="isReadonly"></textarea>
            </mat-form-field>

            <table class="example-full-width" cellspacing="0">
                <tr>
                    <td><mat-form-field class="example-full-width" [class.isReadonly]="isReadonly"
                            [appearance]="fieldAppearance">
                            <mat-label>Trail Type</mat-label>
                            <mat-select name="trailType" [(ngModel)]="selectedTrailType"
                                (ngModelChange)="trailTypeChanged()">
                                @for (trailType of allTrailTypes; track trailType) {
                                <mat-option [value]="trailType">{{trailType.name}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field></td>

                    <td><mat-form-field class="example-full-width" [class.isReadonly]="isReadonly"
                            [appearance]="fieldAppearance">
                            <mat-label>Trail Status</mat-label>
                            <mat-select name="trailStatus" [(ngModel)]="selectedTrailStatus"
                                (ngModelChange)="trailStatusChanged()">
                                @for (trailStatus of allTrailStatus; track trailStatus) {
                                <mat-option [value]="trailStatus">{{trailStatus.name}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field></td>

                    <td><mat-form-field class="example-full-width" [class.isReadonly]="isReadonly"
                            [appearance]="fieldAppearance">
                            <mat-label>Trail Rolling Scheme</mat-label>
                            <mat-select name="trailRollingScheme" [(ngModel)]="selectedTrailRollingScheme"
                                (ngModelChange)="trailRollingSchemeChanged()">
                                @for (trailRollingScheme of allTrailRollingScheme; track trailRollingScheme) {
                                <mat-option [value]="trailRollingScheme">{{trailRollingScheme.name}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field></td>
                </tr>
            </table>

            <table class="example-full-width" cellspacing="0">
                <tr>
                    <td><mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                            <mat-label>Start Date</mat-label>
                            <input matInput type="date" name="start_date" [(ngModel)]="trail.start_date"
                                [readonly]="isReadonly">
                            <mat-hint>DD/MM/YYYY</mat-hint>
                        </mat-form-field></td>
                    <td><mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                            <mat-label>End Date</mat-label>
                            <input matInput type="date" name="end_date" [(ngModel)]="trail.end_date"
                                [readonly]="isReadonly">
                            <mat-hint>DD/MM/YYYY</mat-hint>
                        </mat-form-field></td>
                </tr>
            </table>

            <p>
                <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                    <mat-label>DP Operation Manual</mat-label>
                    <textarea matInput type="text" name="dp_operation_manual" [(ngModel)]="trail.dp_operation_manual"
                        [readonly]="isReadonly"></textarea>
                </mat-form-field>

                <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                    <mat-label>Check List</mat-label>
                    <textarea matInput type="text" name="check_list" [(ngModel)]="trail.check_list"
                        [readonly]="isReadonly"></textarea>
                </mat-form-field>

                <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                    <mat-label>DP Log</mat-label>
                    <textarea matInput type="text" name="dp_log" [(ngModel)]="trail.dp_log"
                        [readonly]="isReadonly"></textarea>
                </mat-form-field>

                <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                    <mat-label>IMCA Guidance</mat-label>
                    <textarea matInput type="text" name="IMCA_guidance" [(ngModel)]="trail.access_to_IMCA_guidance"
                        [readonly]="isReadonly"></textarea>
                </mat-form-field>

                <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                    <mat-label>Records of System Components</mat-label>
                    <textarea matInput type="text" name="records_system_components"
                        [(ngModel)]="trail.records_system_components" [readonly]="isReadonly"></textarea>
                </mat-form-field>
            </p>

        </form>

    </mat-card-content>
</mat-card>